const LearnItem = ({ icon: Icon, description, index }) => {
  const iconBackgrounds = [
    "bg-[#FFF3EE]",
    "bg-[#F3F0FF]",
    "bg-[#ECFDF5]",
    "bg-[#EFF6FF]",
    "bg-[#FFF7ED]",
    "bg-[#FDF2F8]",
  ];

  const iconColors = [
    "text-[#FF6636]",
    "text-[#7C5CFC]",
    "text-[#10B981]",
    "text-[#3B82F6]",
    "text-[#F59E0B]",
    "text-[#EC4899]",
  ];

  const background =
    iconBackgrounds[index % iconBackgrounds.length];

  const iconColor =
    iconColors[index % iconColors.length];

  return (
    <div className="group flex xl:max-w-[910px] flex-col items-start gap-5 rounded-[22px] border border-transparent bg-white px-5 py-5 shadow-[0_4px_20px_rgba(0,0,0,0.10)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_8px_28px_rgba(0,0,0,0.14)] sm:flex-row sm:items-center sm:gap-8 sm:px-6 sm:py-6">
      
      {/* Icon */}
      <div
        className={`flex h-[82px] w-[82px] shrink-0 items-center justify-center rounded-[20px] ${background} transition-transform duration-300 group-hover:scale-105 sm:h-[106px] sm:w-[106px]`}
      >
        {typeof Icon === "string" ? (
          <img src={Icon} alt="" className="h-[46px] w-[46px] object-contain" />
        ) : Icon ? (
          <Icon size={46} strokeWidth={1.8} className={iconColor} />
        ) : null}
      </div>

      {/* Description */}
      <div className="min-w-0 flex-1">
        <p className="text-lg font-semibold leading-7 text-[#111111] sm:text-xl sm:leading-[30px]">
          {description}
        </p>
      </div>
    </div>
  );
};

export default LearnItem;